"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CheckboxField = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var uuid_1 = require("uuid");
var Primitives_1 = require("../Primitives");
var CheckboxField_module_scss_1 = __importDefault(require("./CheckboxField.module.scss"));
/**
 * @deprecated Please use the same component from `@kaizen/components`
 */
var CheckboxField = function (_a) {
    var propsId = _a.id, labelText = _a.labelText, checkedStatus = _a.checkedStatus, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.reversed, reversed = _c === void 0 ? false : _c, _d = _a.noBottomMargin, noBottomMargin = _d === void 0 ? false : _d, automationId = _a.automationId, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["id", "labelText", "checkedStatus", "disabled", "reversed", "noBottomMargin", "automationId", "classNameOverride"]);
    var id = (0, react_1.useState)(propsId || (0, uuid_1.v4)())[0];
    return (react_1["default"].createElement("div", { "data-automation-id": automationId, className: (0, classnames_1["default"])(CheckboxField_module_scss_1["default"].container, classNameOverride, checkedStatus === "on" && CheckboxField_module_scss_1["default"].checked, checkedStatus === "mixed" && CheckboxField_module_scss_1["default"].mixed, reversed && CheckboxField_module_scss_1["default"].reversed, noBottomMargin && CheckboxField_module_scss_1["default"].noBottomMargin) },
        react_1["default"].createElement(Primitives_1.Label, { id: "".concat(id, "-field-label"), htmlFor: "".concat(id, "-field-checkbox"), automationId: "".concat(id, "-field-label"), labelText: labelText, reversed: reversed, labelType: "checkbox", disabled: disabled },
            react_1["default"].createElement(Primitives_1.Checkbox, __assign({ id: "".concat(id, "-field-checkbox"), automationId: "".concat(id, "-field-checkbox"), disabled: disabled, reversed: reversed, checkedStatus: checkedStatus }, restProps)))));
};
exports.CheckboxField = CheckboxField;
exports.CheckboxField.displayName = "CheckboxField";
//# sourceMappingURL=CheckboxField.js.map